export const PRAGMATIC_PROVIDER_ID = 49;
export const PRAGMATIC_LIVE_PROVIDER_ID = 96;
